import { type ApolloError } from '@apollo/client'

export function getGqlErrorStatusCode(error: ApolloError | undefined): number | undefined {
  return error?.graphQLErrors?.[0]?.extensions?.statusCode
}
